import React from "react";
import { Box, Stack, Text } from "@mantine/core";
import { AppResources } from "@/constants";

/**
 * Empty state component with animated coin
 */
export const EmptyReferralState: React.FC = () => {
  return (
    <>
      <style>
        {`
          @keyframes spinCoin {
            from {
              transform: rotateY(0deg);
            }
            to {
              transform: rotateY(360deg);
            }
          }

          .wizzy-coin {
            animation: spinCoin 3s linear infinite;
            transition: transform 0.3s ease;
          }

          .wizzy-coin-container:hover .wizzy-coin {
            animation-play-state: paused;
            transform: scale(1.2) rotateY(0deg);
          }
        `}
      </style>
      <Stack align="center" py="xl" gap="xl">
        <Box
          className="wizzy-coin-container"
          style={{
            display: "inline-block",
          }}
        >
          <img
            src={AppResources.wizzyCoin}
            alt="Wizzy Coin"
            className="wizzy-coin"
            style={{
              width: 120,
              height: 120,
              objectFit: "contain",
            }}
          />
        </Box>
        <Stack gap="xs" align="center">
          <Text size="lg" fw={600} c="dimmed">
            No referrals yet
          </Text>
          <Text size="sm" c="dimmed" ta="center" maw={400}>
            Start sharing your referral link to earn rewards for every tax
            professional who becomes a paying customer!
          </Text>
        </Stack>
      </Stack>
    </>
  );
};
